import React, { useState, useEffect } from "react";
import { Button, Modal, Space } from "antd";

const ModalDeleteDevice = ({ closeModal, open, submitModal, data }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOk = () => {
    setOpenModal(false);
    submitModal();
  };
  const handleCancel = () => {
    setOpenModal(false);
    closeModal();
  };

  useEffect(() => {
    if (open) {
      setOpenModal(open);
    }
  }, [open]);

  return (
    <Modal
      title={<div style={styles.title}>คุณต้องการลบอุปกรณ์นี้หรือไม่</div>}
      open={openModal}
      onOk={handleOk}
      onCancel={handleCancel}
      centered={true}
      width="550px"
      footer={
        <>
          <Space size={"large"}>
            <Button style={styles.buttonCancel} onClick={handleCancel}>
              No
            </Button>
            <Button style={styles.buttonOk} onClick={handleOk}>
              Yes
            </Button>
          </Space>
        </>
      }
    >
      <div>
        <div>
          {data.id} {data.room_name} {data.device_model} {data.device_name}{" "}
          {data.device_type}
        </div>
      </div>
    </Modal>
  );
};

const styles = {
  layout: {
    fontFamily: "Kanit",
    padding: "20px",
    borderRadius: "8px",
    background: "#FFF",
    marginBottom: "10px",
  },
  title: {
    color: "#4F4F4F",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "150%",
    marginBottom: "20px",
  },
  buttonOk: {
    borderRadius: "6px",
    border: "1px solid #FFC700",
    background: "#FFC700",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
  buttonCancel: {
    borderRadius: "6px",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    background: "#FFF",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#2A5885",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
};

export default ModalDeleteDevice;
